import { render, staticRenderFns } from "./TabShareGuestDocumentation.vue?vue&type=template&id=29a062b3&"
import script from "./TabShareGuestDocumentation.vue?vue&type=script&lang=js&"
export * from "./TabShareGuestDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports